import PostRegistrationModalContainer from './PostRegistrationModalContainer';

export default PostRegistrationModalContainer;
